import { InventoryServiceLevelDTO } from '../dto/InventoryServiceLevelDTO';
import { InventoryServiceLevel } from '@domain/inventory/models/InventoryServiceLevel';

export class InventoryServiceLevelMapper {
  static toModel(dto: InventoryServiceLevelDTO): InventoryServiceLevel {
    return {
      serviceLevelPercent: dto.serviceLevelPercent,
      total: dto.total,
    };
  }
}
